import { RootState } from '../../types/redux/states/RootState';

export const getAnalyticsConfig = ({ analytics }: RootState) => analytics;
